module.exports = __webpack_public_path__ + "6543afa7ac24646008ba7ba0f86f0b5d.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Header/logo.png
 ** module id = 666
 ** module chunks = 0
 **/